export default "__VITE_ASSET__de81f2d9__"